import ServerRequestUtil from '../utils/ServerRequestUtil';
import AuthUtil from '../utils/AuthUtil';
import JSCookie from 'js-cookie';

export default new class {

    constructor() {
    }

    async getReserveHecSavingSettingHistory() {
      return ServerRequestUtil.get('/api/app/hec-saving/reserve-setting-history');
    }

    async setReserveHecSavingSettingHistory(registrationData) {
      return ServerRequestUtil.post('/api/app/hec-saving/reserve-setting-history/set', {...registrationData});
    }
}
